export default __webpack_public_path__ + "static/media/helpCircleIcon.fc402921.png";